import React from 'react';
import { Contact } from '../components/contact';
import { PageLayout } from '../components/page-layout';
import { getNav } from '../lib/get-nav';
import { initializeApollo } from '../lib/auth/apollo';

export async function getStaticProps() {
  const apolloClient = initializeApollo();

  await getNav(apolloClient);

  return {
    props: {
      initialApolloState: apolloClient.cache.extract(),
    },
    revalidate: 100,
  };
}
const ContactPage = () => {
  return (
    <PageLayout authWall={false}>
      <Contact />
    </PageLayout>
  );
};

export default ContactPage;
